import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { connect } from 'react-redux';
import { Trans, useTranslation } from "react-i18next";
import { currency, getStoreType } from "../../../../dynamicController";
import { Modal } from "antd";
import { savePage } from "../../../../redux/actions/kioskActions";

import insufficientToken from "../../../../assets/images/icons/icn-creditInsufficient.png";
import LaundroVending from "../../../user/utilities/payment/Vending/LaundroVending";

import CleanproVendingPayment from "../cleanpro/VendingPayment"
import LaundroVendingPayment from "../laundro/VendingPayment"

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const VendingPayment = ({ machine, outlet, user, theme, userLogout, setSendThis, setPage, setShowOverlay, setEndpoint, kioskVersion, savePage }) => {
	const [amount, setAmount] = useState(machine.minPrice ? machine.minPrice : STORETYPE === "cuci" ? 2 : machine.country === "Thailand" ? 10 : 1);
	const [razerBody, setRazerBody] = useState(null);
	const [ghlBody, setGhlBody] = useState(null);
	const [loading, setLoading] = useState(false)
	const [paymentMethodModal, setPaymentMethodModal] = useState(false)
	const [paymentConfirmationModal, setPaymentConfirmationModal] = useState(false)
	const [paymentConfirmationText, setPaymentConfirmationText] = useState("")
	const [insufficientTokenModal, setInsufficientTokenModal] = useState(false)
	const [paymentMethod, setPaymentMethod] = useState("")
	const [url, setUrl] = useState("");
	const [body, setBody] = useState([])
	const [formName, setFormName] = useState("")
	const [isOpen, setOpen] = useState(false);
	const [voucherDiscountAmount, setVoucherDiscountAmount] = useState(null);
	const [discountCodeDiscountAmount, setDiscountCodeDiscountAmount] = useState(null);
	const [voucherId, setVoucherId] = useState(null);
	const [discountCode, setDiscountCode] = useState("");
	const [discountCodeInput, setDiscountCodeInput] = useState("");
	const [discountCodeModal, setDiscountCodeModal] = useState(false);
	const [id, setId] = useState(null);
	const [point, setPoint] = useState(false);
	const [voucherReminderModal, setVoucherReminderModal] = useState(false)

	const formButtonClick = useRef();
	const razerButtonClick = useRef();
	const ghlButtonClick = useRef();

	const history = useHistory();
	const { t } = useTranslation();

	useEffect(() => {
		if (razerBody) {
			razerButtonClick.current.click();
		}
	}, [razerBody]);

	useEffect(() => {
		if (ghlBody) {
			ghlButtonClick.current.click();
		}
	}, [ghlBody]);

	useEffect(() => {
		if (body.length > 0) {
			formButtonClick.current.click();
		}
	}, [body]);

	const minusAmount = () => {
		const step = parseFloat(machine.step || 1);
		const newAmount = amount - step;
		if (newAmount >= (machine.minPrice || step)) setAmount(newAmount);
	};

	const addAmount = () => {
		const step = parseFloat(machine.step || 1);
		const newAmount = amount + step;
		if (newAmount <= (machine.maxPrice || 100)) setAmount(newAmount);
	};

	const discountText = (type) => {
		let discountValue = null;

		if (type === "Voucher" && voucherId && voucherDiscountAmount) {
			discountValue = voucherDiscountAmount;
		} else if (type === "Discountcode" && discountCode && discountCodeDiscountAmount) {
			discountValue = discountCodeDiscountAmount;
		}

		if (discountValue) {
			if (discountValue.type === "Flat") {
				if (STORETYPE === "cleanpro" && user && user.tokenSetting) {
					return `${discountValue.amount} ${t("credit")}`
				} else {
					return `${currency(machine.country)} ${discountValue.amount}`
				}
			} else {
				return `${discountValue.amount} %`
			}
		}
	};

	const getPaymentAmount = (type) => {
		let payAmount = parseFloat(amount);
		let pointAmount = 0;

		if (voucherId && voucherDiscountAmount) {
			// voucher
			if (voucherDiscountAmount.type === "Flat") {
				payAmount = parseFloat(payAmount) - parseFloat(voucherDiscountAmount.amount)
			} else {
				const rate = (parseFloat(amount) * parseFloat(voucherDiscountAmount.amount)) / 100
				payAmount = (parseFloat(payAmount) - rate).toFixed(2)
			}
		} else if (discountCode && discountCodeDiscountAmount) {
			// discount code
			if (discountCodeDiscountAmount.type === "Flat") {
				payAmount = parseFloat(payAmount) - parseFloat(discountCodeDiscountAmount.amount)
			} else {
				const rate = (parseFloat(amount) * parseFloat(discountCodeDiscountAmount.amount)) / 100
				payAmount = (parseFloat(payAmount) - rate).toFixed(2)
			}
		}

		if (payAmount <= 0) {
			payAmount = 0;
		}

		// point
		if (point) {
			if (parseFloat(user.point) >= (parseFloat(payAmount) * parseFloat(user.point_currency))) {
				// if user has sufficient points to pay (all amount paid using points)
				pointAmount = parseFloat(payAmount) * parseFloat(user.point_currency);
				payAmount = 0;
			} else {
				// use up all the current points and the user still needs to pay for the remaining amount
				pointAmount = parseFloat(user.point);
				payAmount = parseFloat(payAmount) - (parseFloat(user.point) / parseFloat(user.point_currency));
			}
		}

		if (type === "paymentAmount") {
			// machine payment amount
			return /\./g.test(payAmount.toString()) ? parseFloat(payAmount).toFixed(2) : payAmount;
		} else if (type === "pointAmount") {
			// point amount used for discount
			return pointAmount;
		} else if (type === "pointValue") {
			// point amount used for discount in RM
			return /\./g.test((parseFloat(pointAmount) / parseFloat(user.point_currency)).toString()) ?
				(parseFloat(pointAmount) / parseFloat(user.point_currency)).toFixed(2) :
				(parseFloat(pointAmount) / parseFloat(user.point_currency));
		}
	}

	const checkDiscountCode = (e) => {
		e.preventDefault();

		if (user) {
			setLoading(true);
			axios
				.post("/api/user/checkDiscountCode", {
					discountCode: discountCodeInput,
					outletId: machine.outletId,
					machineType: machine.type,
					userId: user.id,
				})
				.then((res) => {
					let typ = res.data.discountType;
					let amt = parseFloat(res.data.discountAmount);
					setDiscountCode(discountCodeInput);
					setDiscountCodeDiscountAmount({ type: typ, amount: amt })
					setVoucherId(null);
					setVoucherDiscountAmount(null)
					setDiscountCodeModal(false);
					setLoading(false);
				})
				.catch((err) => {
					setDiscountCodeInput("");
					setLoading(false);
					mySwal.fire(t("Error"), t(err.response.data.error), "error");
				});
		}
	};

	const useVoucher = (e) => {
		if (id) {
			let foundVoucher = user.vouchers.filter((v) => v.id === id)[0];
			if (user) {
				setVoucherDiscountAmount({ type: foundVoucher.type, amount: foundVoucher.amount })
				setVoucherId(foundVoucher.id);
				setDiscountCode("")
				setDiscountCodeDiscountAmount(null)
				setOpen(false);
			}
		}
	};

	const chooseVoucher = (typ, amt, id) => {
		if (user) {
			setVoucherDiscountAmount({ type: typ, amount: amt })
			setVoucherId(id);
			setDiscountCode("")
			setDiscountCodeDiscountAmount(null)
			setOpen(false);
		}
	};

	const removeVoucher = () => {
		setVoucherDiscountAmount(null)
		setOpen(false);
		setVoucherId(null);
		setDiscountCode("");
		setDiscountCodeInput("");
		setDiscountCodeDiscountAmount(null)
		setDiscountCodeModal(false);
	};

	const renderVouchers = () => {
		if (user) {
			if (user.vouchers && user.vouchers.length) {
				let filteredVouchers = []
				if (machine.type === "Vending Machine") {
					filteredVouchers = user.vouchers.filter((voucher) => voucher.available && voucher.vending_use)
				} else if (machine.type === "Detergent Vending") {
					filteredVouchers = user.vouchers.filter((voucher) => voucher.available && voucher.detergent_use)
				} else if (machine.type === "Car Wash") {
					filteredVouchers = user.vouchers.filter((voucher) => voucher.available && voucher.carwash_use)
				}
				return filteredVouchers
					.map((voucher) => {
						let currentVoucherAmount = voucher.amount
						return (
							<div key={voucher.id} className="payment-voucher">
								{STORETYPE === "cleanpro" ? (
									<div
										style={{ borderRadius: "0" }}
										className="voucher my-3"
									>
										<div
											className="voucher-content center-content"
											style={{
												color: "black",
												position: "relative",
												zIndex: "99",
												marginTop: "1em",
											}}
										>
											<div
												className="d-flex"
												style={{
													width: "50%",
													flexDirection: "column",
													justifyContent: "center",
													alignContent: "center",
													marginLeft: "1em",
													textAlign: "left",
												}}
											>
												<h2 className="font-weight-bold">
													{voucher.type === "Flat" ? <Trans i18nKey="voucherCreditsOff" count={currentVoucherAmount}>{{ currentVoucherAmount }} Credits OFF</Trans> : <Trans i18nKey="voucherPercentageOff" count={currentVoucherAmount}>{{ currentVoucherAmount }}% OFF</Trans>}
												</h2>

												<small>{voucher.description}</small>

												{voucher.expired_date ? (
													<h6 style={{ color: "grey" }} className="m-0 p-0">
														<small>{t("Valid Till")}: {new Date(voucher.expired_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</small>
													</h6>
												) : null}

											</div>
											<div
												style={{ width: "30%" }}
												className="center-content"
											>
												<input
													onChange={() => setId(voucher.id)}
													style={{
														border: "1px solid grey",
														cursor: "pointer",
														opacity: "1",
														pointerEvents: "fill",
														position: "relative",
													}}
													type="radio"
													name="paymentVoucher"
													id={voucher.id}
												/>
											</div>
										</div>
									</div>
								) : (
									<div
										onClick={(e) => chooseVoucher(voucher.type, voucher.amount, voucher.id)}
										className="list-group-item"
									>
										<p>{voucher.title}</p>
										<h6>
											{t("Discount")} :- {voucher.type === "Flat" ? currency(machine.country) : null}
											{voucher.amount}
											{voucher.type === "Rate" ? "%" : null}
										</h6>
									</div>
								)}
							</div>
						);
					});
			} else {
				return (
					<div className="mt-4">
						<p style={{ color: "red" }}>{t("No Vouchers Available")}</p>
					</div>
				);
			}
		} else {
			return null;
		}
	};

	const handleSubmit = () => {
		let voucherReminder = false;
		let filteredVouchers = []

		if (user) {
			if (user.vouchers && user.vouchers.length) {
				if (machine.type === "Vending Machine") {
					filteredVouchers = user.vouchers.filter((voucher) => voucher.available && voucher.vending_use)
				} else if (machine.type === "Detergent Vending") {
					filteredVouchers = user.vouchers.filter((voucher) => voucher.available && voucher.detergent_use)
				} else if (machine.type === "Car Wash") {
					filteredVouchers = user.vouchers.filter((voucher) => voucher.available && voucher.carwash_use)
				}

				if (filteredVouchers.length > 0 && !voucherId && !discountCode) {
					voucherReminder = true;
				}
			}
		}

		if (amount && amount >= 0) {
			savePage("Kiosk")
			if (machine.online && machine.outletStatus === "online") {
				if (voucherReminder) {
					setVoucherReminderModal(true)
				} else {
					setPaymentMethodModal(true)
				}
			} else {
				mySwal.fire(t("Error"), t("This machine is currently offline, please try again later."), "error")
			}
		} else {
			mySwal.fire(t("Error"), t("Payment amount should be greater than 0"), "error")
		}
	};

	const handlePaymentMethod = (method) => {
		if (method === "eToken" && (parseFloat(user.token) < parseFloat(getPaymentAmount("paymentAmount")))) {
			setInsufficientTokenModal(true)
			setPaymentMethodModal(false)
		} else {
			setPaymentMethod(method)
			if (method === "eToken") {
				setPaymentConfirmationText(<p className="text-center">{t("You have")} <strong>{user.token}</strong> {STORETYPE === "cleanpro" ? t("credits") : t("e-Tokens")}.<br />{t("Pay")} <strong>{getPaymentAmount("paymentAmount")}</strong> {STORETYPE === "cleanpro" ? t("credits") : t("e-Tokens")} {("to")} <strong>{machine.name}</strong>?</p>)
			} else if (method === "duitnow") {
				setPaymentConfirmationText(<p className="text-center"><Trans i18nKey="The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency }}{{ totalPaymentAmount }} to {{ machineName }}?">The Duitnow QR code will be downloaded and you need to open your banking app to make the payment. Pay {{ currency: currency(machine.country) }}{{ totalPaymentAmount: getPaymentAmount("paymentAmount") }} to {{ machineName: machine.name }}?</Trans></p>)
			} else {
				if (voucherId && voucherDiscountAmount && voucherDiscountAmount.type === "Flat" && (voucherDiscountAmount.amount > amount)) {
					setPaymentConfirmationText(<p className="text-center">{t("You may under utilized the voucher.")} {t("Proceed to pay")} {currency(machine.country)} {getPaymentAmount("paymentAmount")} {t("to")} {machine.name}?</p>)
				} else {
					setPaymentConfirmationText(<p className="text-center">{t("Pay")} {currency(machine.country)} {getPaymentAmount("paymentAmount")} {t("to")} {machine.name}?</p>)
				}
			}
			setPaymentMethodModal(false)
			setPaymentConfirmationModal(true)
		}
	}

	const confirmPayment = () => {
		setLoading(true)
		let sendThis = {
			amount: parseFloat(amount).toFixed(2),
			paymentAmount: getPaymentAmount("paymentAmount"),
			machine,
			outlet,
			kiosk: true
		};

		let endPoint = "/api/nonuser/payment";

		let headers = {
			"Content-Type": "application/json"
		}

		if (user) {
			sendThis.voucherId = voucherId;
			sendThis.memberId = user.memberId;
			sendThis.discountCode = discountCode;
			sendThis.point_amount = getPaymentAmount("pointAmount");
			sendThis.point_currency = user.point_currency;
			endPoint = "/api/user/payment";
		}

		if (paymentMethod === "eToken") {
			sendThis.token = true
		} else if (paymentMethod === "duitnow") {
			if (machine.duitnow) {
				sendThis.duitnow = true
			} else if (machine.rhbduitnow) {
				sendThis.rhbduitnow = true
			}
		} else if (paymentMethod === "paywave") {
			sendThis.terminal = true
		} else if (paymentMethod === "promptpay") {
			sendThis.bangkokbank = true
		} else if (paymentMethod === "bangkokbank") {
			sendThis.osPlatform = /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "IOS" : "ANDROID";
			sendThis.bangkokbanklink = true
		}

		if (paymentMethod === "eWallet" && machine.outletType === "pagbank" && parseFloat(getPaymentAmount("paymentAmount")) > 0) {
			let data = {
				country: machine.country,
				description: machine.name,
				paymentAmount: getPaymentAmount("paymentAmount"),
				user,
				endPoint,
				sendThis,
				pagbankPublicKey: machine.pagbankPublickKey,
			}
			history.push("/payment/pagbank", data)
		} else if (paymentMethod === "eWallet" && machine.outletType === "payway" && parseFloat(getPaymentAmount("paymentAmount")) > 0) {
			let data = {
				country: machine.country,
				description: machine.name,
				paymentAmount: getPaymentAmount("paymentAmount"),
				user,
				endPoint,
				sendThis,
			}
			history.push("/payment/payway", data)
		} else {
			axios
				.post(endPoint, sendThis, { headers })
				.then(res => {
					setPaymentConfirmationModal(false)
					setLoading(false)
					if (res.data.status === "rm") {
						window.location.href = res.data.data;
					} else if (res.data.status === "laundro") {
						userLogout()
					} else if (res.data.status === "razer") {
						setRazerBody(res.data.data)
					} else if (res.data.status === "duitnow") {
						history.push("/guide/duitnow", { url: res.data.data, transactionId: res.data.transactionId, title: res.data.title, createdAt: res.data.createdAt })
					} else if (res.data.status === "ghl") {
						setGhlBody(res.data.data)
					} else if (res.data.status === "terminal") {
						history.push("/guide/terminal", { transactionId: res.data.transactionId })
					} else if (res.data.status === "rhbduitnow") {
						history.push("/guide/duitnow", { image: `data:image/png;base64,${res.data.data.data}`, transactionId: res.data.transactionId, title: res.data.title, createdAt: res.data.createdAt })
					} else if (res.data.status === "bangkokbank") {
						history.push("/guide/promptpay", { image: res.data.data, transactionId: res.data.transactionId })
					} else if (res.data.status === "bangkokbanklink") {
						history.push("/guide/bangkokbanklink", { url: res.data.data, transactionId: res.data.transactionId })
					} else if (res.data.status === "form") {
						setUrl(res.data.data.url)
						setBody(res.data.data.body)
						if (res.data.data.formName) {
							setFormName(res.data.data.formName)
						}
					} else if (res.data.status === "url") {
						window.location.href = res.data.data.url;
					} else if (res.data.status === "image" && paymentMethod === "duitnow") {
						let duitnowState = { transactionId: res.data.transactionId, title: res.data.title, createdAt: res.data.createdAt }
						if (res.data.data.url) {
							duitnowState.url = res.data.data.url
						}
						if (res.data.data.image) {
							duitnowState.image = res.data.data.image
						}
						history.push("/guide/duitnow", duitnowState)
					} else if (res.data.status === "image" && paymentMethod === "promptpay") {
						history.push("/guide/promptpay", { image: res.data.data.url, transactionId: res.data.transactionId })
					} else {
						userLogout()
					}
				})
				.catch(err => {
					setLoading(false)
					mySwal.fire(t("Error"), t(err.response.data.error), "error")
				})
		}
	}

	return (
		<div id="vending-machine" className="mt-4">

			{
				STORETYPE === "cleanpro"
					? <CleanproVendingPayment
						machine={machine}
						user={user}
						setPage={setPage}
						outlet={outlet}
						setSendThis={setSendThis}
						setShowOverlay={setShowOverlay}
						setEndpoint={setEndpoint}
					/>
					: kioskVersion === 2 ? (
						<LaundroVendingPayment
							amount={amount}
							machine={machine}
							user={user}
							setPage={setPage}
							outlet={outlet}
							setSendThis={setSendThis}
							setShowOverlay={setShowOverlay}
							setEndpoint={setEndpoint}
							minusAmount={minusAmount}
							addAmount={addAmount}
						/>
					) : <LaundroVending
						amount={amount}
						setAmount={setAmount}
						machine={machine}
						minusAmount={minusAmount}
						addAmount={addAmount}
						handleSubmit={handleSubmit}
						user={user}
						discountCode={discountCode}
						voucherId={voucherId}
						setDiscountCodeModal={setDiscountCodeModal}
						discountCodeDiscountAmount={discountCodeDiscountAmount}
						setOpen={setOpen}
						point={point}
						setPoint={setPoint}
						discountText={discountText}
						getPaymentAmount={getPaymentAmount}
						isOpen={isOpen}
						removeVoucher={removeVoucher}
						renderVouchers={renderVouchers}
					/>
			}

			{
				body ? (
					<div>
						<form name={formName} action={url} method="post">
							{
								body.map(b => (
									<input type="hidden" name={b.name} value={b.value} />
								))
							}
							<input type="submit" name="submit" value="Pay" hidden ref={formButtonClick} />
						</form>
					</div>
				) : null
			}

			{
				razerBody ? (
					<div>
						<form action={razerBody.paymentDomain} method="post">
							<input type="hidden" name="amount" value={razerBody.amount} />
							<input type="hidden" name="merchant_id" value={razerBody.merchant_id} />
							<input type="hidden" name="orderid" value={razerBody.orderid} />
							{razerBody.bill_name ? <input type="hidden" name="bill_name" value={razerBody.bill_name} /> : null}
							{razerBody.bill_email ? <input type="hidden" name="bill_email" value={razerBody.bill_email} /> : null}
							{razerBody.bill_mobile ? <input type="hidden" name="bill_mobile" value={razerBody.bill_mobile} /> : null}
							<input type="hidden" name="bill_desc" value={razerBody.bill_desc} />
							<input type="hidden" name="country" value={razerBody.country} />
							<input type="hidden" name="vcode" value={razerBody.vcode} />
							<input type="hidden" name="currency" value={razerBody.currency} />
							<input type="hidden" name="returnurl" value={razerBody.returnurl} />
							<input type="hidden" name="callbackurl" value={razerBody.callbackurl} />
							<input type="hidden" name="cancelurl" value={razerBody.cancelurl} />

							<input type="submit" name="submit" value="Pay with razer" hidden ref={razerButtonClick} />
						</form>
					</div>
				) : null
			}

			{
				ghlBody ? (
					<div>
						<form name="frmPayment" method="post" action={ghlBody.frmPayment}>
							<input type="hidden" name="TransactionType" value={ghlBody.TransactionType} />
							<input type="hidden" name="PymtMethod" value={ghlBody.PymtMethod} />
							<input type="hidden" name="ServiceID" value={ghlBody.ServiceID} />
							<input type="hidden" name="PaymentID" value={ghlBody.PaymentID} />
							<input type="hidden" name="OrderNumber" value={ghlBody.OrderNumber} />
							<input type="hidden" name="PaymentDesc" value={ghlBody.PaymentDesc} />
							<input type="hidden" name="MerchantReturnURL" value={ghlBody.MerchantReturnURL} />
							{ghlBody.MerchantCallBackURL ? <input type="hidden" name="MerchantCallBackURL" value={ghlBody.MerchantCallBackURL} /> : null}
							<input type="hidden" name="Amount" value={ghlBody.Amount} />
							<input type="hidden" name="CurrencyCode" value={ghlBody.CurrencyCode} />
							<input type="hidden" name="CustIP" value={ghlBody.CustIP} />
							<input type="hidden" name="CustName" value={ghlBody.CustName} />
							<input type="hidden" name="CustEmail" value={ghlBody.CustEmail} />
							<input type="hidden" name="CustPhone" value={ghlBody.CustPhone} />
							<input type="hidden" name="HashValue" value={ghlBody.HashValue} />
							<input type="hidden" name="PageTimeout" value={ghlBody.PageTimeout} />

							<input type="submit" name="submit" value="Pay with GHL" hidden ref={ghlButtonClick} />
						</form>

					</div>
				) : null
			}

			<Modal
				open={discountCodeModal}
				onCancel={(e) => setDiscountCodeModal(false)}
				footer={null}
				closable={true}
				centered
				title={t("Enter Discount Code")}
			>
				<div>
					<form onSubmit={checkDiscountCode}>
						{discountCode ? (
							<div className="form-group text-left">
								<label htmlFor="code">{t("Discount Code")}</label>
								<input
									type="text"
									id="code"
									name="code"
									value={discountCode}
									className="form-control browser-default"
									readOnly
								/>
							</div>
						) : (
							<div className="form-group text-left">
								<label htmlFor="code">{t("Discount Code")}</label>
								<input
									type="text"
									id="code"
									name="code"
									value={discountCodeInput}
									className="form-control browser-default"
									onChange={(e) =>
										setDiscountCodeInput(e.target.value.toUpperCase())
									}
									required
								/>
							</div>
						)}

						<div className="text-center pt-3">
							{loading ? (
								<div className="text-center">
									<div
										className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`}
										role="status"
									>
										<span className="sr-only">Loading...</span>
									</div>
								</div>
							) : discountCode ? (
								<input
									id="remove-discount-code"
									type="button"
									value={t("Remove Code")}
									onClick={() => removeVoucher()}
									className="btn btn-primary mx-2"
								/>
							) : (
								<input
									id="submit-discount-code"
									type="submit"
									value={t("Submit")}
									className="btn btn-primary mx-2"
								/>
							)}
							<button
								id="close-discount-code"
								type="button"
								className="btn btn-secondary"
								onClick={(e) => setDiscountCodeModal(false)}
							>
								{t("Close")}
							</button>
						</div>
					</form>
				</div>
			</Modal>

			<Modal
				open={insufficientTokenModal}
				onCancel={(e) => setInsufficientTokenModal(false)}
				footer={null}
				closable={false}
				centered
			>
				<div className={theme}>
					{
						STORETYPE === "cleanpro" ? (
							<img
								className="d-block pb-3"
								src={insufficientToken}
								style={{ width: "64px", margin: "0 auto" }}
								alt=""
							/>
						) : null
					}
					<h2 className="text-center pb-2">{STORETYPE === "cleanpro" ? t("Insufficient balance") : t("Insufficient e-Tokens")}</h2>
					{STORETYPE === "cleanpro" ? <p className="text-center" style={{ fontSize: "16px", fontWeight: 300 }}>{t("Oops. You don't have enough balance to make the payment")}</p> : <p className="text-center">{t("Reload your e-token now?")}</p>}
					<div className={`d-flex pt-3 justify-content-center ${STORETYPE === "cleanpro" ? "flex-row-reverse" : ""}`}>
						<button id="cleanpro-topup-now" onClick={() => userLogout()} className="btn btn-primary cleanpro-swal-btn washup-swal-btn mx-1 reload-token" style={{ backgroundColor: STORETYPE === "cleanpro" ? "#004FC1" : STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}>
							{STORETYPE === "cleanpro" ? t("Topup now") : t("Reload now!")}
						</button>
						<button id="cleanpro-cancel-topup" onClick={() => setInsufficientTokenModal(false)} className="btn btn-secondary cleanpro-swal-secondary-btn washup-swal-btn mx-1 cancel-reload-token">
							{STORETYPE === "cleanpro" ? t("Back") : t("Cancel")}
						</button>
					</div>
				</div>
			</Modal>

			<Modal
				open={paymentMethodModal}
				onCancel={(e) => setPaymentMethodModal(false)}
				footer={null}
				closable={false}
				centered
			>
				<div className={theme}>
					<h2 className="text-center pb-2">{STORETYPE === "cleanpro" ? t("Payment methods") : t("Payment Method")}</h2>
					<p className="text-center">{STORETYPE === "cleanpro" ? t("Tap to proceed with your preferred mode of payment") : t("Would you like to pay with?")}</p>
					<div className="pt-3 d-flex flex-wrap justify-content-center">
						{
							user && user.tokenSetting ? (
								<button
									type="button"
									className="btn btn-primary cleanpro-swal-big-primary-btn washup-swal-btn e-wallet mx-1 my-1"
									style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#CFA82C" : "#2778c4" }}
									onClick={(e) => handlePaymentMethod("eToken")}
								>
									{STORETYPE === "cleanpro" ? t("Cleanpro Plus credits") : t("e-Token")}
								</button>
							) : null
						}
						{
							machine.epayment && machine.kioskewallet ? (
								<button
									type="button"
									className="btn btn-primary cleanpro-swal-big-primary-btn washup-swal-btn e-token mx-1 my-1"
									style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
									onClick={(e) => handlePaymentMethod("eWallet")}
								>
									{STORETYPE === "cleanpro" ? `${t("E-wallet or credit/debit cards")} >` : t("E-Wallet & Online Banking")}
								</button>
							) : null
						}
						{
							(machine.duitnow || machine.rhbduitnow) && machine.kioskqr ? (
								<button
									type="button"
									className="btn btn-primary cleanpro-swal-big-primary-btn washup-swal-btn duitnow mx-1 my-1"
									style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
									onClick={(e) => handlePaymentMethod("duitnow")}
								>
									{t("Duitnow QR code")}
								</button>
							) : null
						}
						{
							machine.terminal && machine.kioskterminal ? (
								<button
									type="button"
									className="btn btn-primary cleanpro-swal-big-primary-btn washup-swal-btn terminal mx-1 my-1"
									style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
									onClick={(e) => handlePaymentMethod("paywave")}
								>
									{t("Paywave")}
								</button>
							) : null
						}
						{
							machine.bangkokbank ? (
								<button
									type="button"
									className="btn btn-primary cleanpro-swal-big-primary-btn washup-swal-btn promptpay mx-1 my-1"
									style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
									onClick={(e) => handlePaymentMethod("promptpay")}
								>
									{t("PromptPay QR Code")}
								</button>
							) : null
						}
						{
							machine.bangkokbanklink ? (
								<button
									type="button"
									className="btn btn-primary cleanpro-swal-big-primary-btn washup-swal-btn bangkokbank mx-1 my-1"
									style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
									onClick={(e) => handlePaymentMethod("bangkokbank")}
								>
									{t("Bangkok Bank")}
								</button>
							) : null
						}
						<button
							type="button"
							className="btn btn-secondary cleanpro-swal-big-secondary-btn washup-swal-btn cancel-payment mx-1 my-1"
							style={{ backgroundColor: STORETYPE === "cleanpro" ? "#004FC1" : "#6C757D" }}
							onClick={(e) => setPaymentMethodModal(false)}
						>
							{t("Cancel")}
						</button>
					</div>
				</div>
			</Modal>

			<Modal
				open={voucherReminderModal}
				onCancel={(e) => setVoucherReminderModal(false)}
				footer={null}
				closable={false}
				centered
			>
				<div className={theme}>
					<h2 className="text-center pb-2">{t("You haven't applied your voucher")}</h2>
					<p className="text-center">{t("Would you like to continue your payment without using your voucher?")}</p>
					<div className="d-flex pt-3 justify-content-center">
						<button
							type="button"
							className="btn btn-primary pay-without-voucher cleanpro-swal-secondary-btn washup-swal-btn mx-1"
							style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
							onClick={(e) => { setVoucherReminderModal(false); setPaymentMethodModal(true) }}
						>
							{t("Continue")}
						</button>

						<button
							type="button"
							className="btn btn-secondary apply-voucher cleanpro-swal-btn washup-swal-btn mx-1"
							onClick={(e) => { setVoucherReminderModal(false); setOpen(true) }}
						>
							{t("Apply voucher")}
						</button>
					</div>
				</div>
			</Modal>

			<Modal
				open={paymentConfirmationModal}
				onCancel={(e) => setPaymentConfirmationModal(false)}
				footer={null}
				closable={false}
				centered
				maskClosable={false}
			>
				<div className={theme}>
					<div className="text-center">
						<i className="bi bi-question-circle" style={{ color: "#87adbd", fontSize: "70px" }}></i>
					</div>
					<h2 className="text-center pb-2">{t("Confirmation")}</h2>
					{paymentConfirmationText ? <div>{paymentConfirmationText}</div> : null}
					<div className={`d-flex pt-3 justify-content-center ${STORETYPE === "cleanpro" ? "flex-row-reverse" : ""}`}>
						{
							loading ? (
								<div className="text-center">
									<div
										className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`}
										role="status"
									>
										<span className="sr-only">Loading...</span>
									</div>
								</div>
							) : (
								<>
									<button
										type="button"
										className="btn btn-primary cleanpro-swal-btn washup-swal-btn mx-1"
										style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
										onClick={(e) => confirmPayment()}
										disabled={loading}
									>
										{STORETYPE === "cleanpro" ? t("Pay now") : t("OK")}
									</button>

									<button
										type="button"
										className="btn btn-secondary cleanpro-swal-secondary-btn washup-swal-btn mx-1"
										onClick={(e) => setPaymentConfirmationModal(false)}
									>
										{STORETYPE === "cleanpro" ? t("Cancel") : t("No")}
									</button>
								</>
							)
						}
					</div>
				</div>
			</Modal>
		</div>
	)
}

const mapDispatchToProps = dispatch => {
	return {
		savePage: (data) => dispatch(savePage(data)),
	};
};

export default connect(null, mapDispatchToProps)(VendingPayment);